import { TStage } from 'src/types';

type TempusClinicalVariableValues = {
  psa?: number | null;
  tStage?: TStage | null;
  labProcedureDatePhi?: string | null;
};

/** Whether PSA, T-stage, and procedure date are all present for Tempus metastatic orders. */
export function isMetastaticTempusClinicalDataComplete(
  values: TempusClinicalVariableValues,
): boolean {
  const psa = values.psa;
  const hasPsa = typeof psa === 'number' && Number.isFinite(psa);
  const tStage = values.tStage as unknown;
  const hasTStage =
    tStage !== null &&
    tStage !== undefined &&
    tStage !== '' &&
    !(typeof tStage === 'string' && tStage.trim() === '');
  const dateStr = values.labProcedureDatePhi;
  const hasProcedureDate =
    dateStr !== null && dateStr !== undefined && String(dateStr).trim() !== '';
  return hasPsa && hasTStage && hasProcedureDate;
}

export function hasMissingTempusClinicalVariables(
  values: TempusClinicalVariableValues,
): boolean {
  return !isMetastaticTempusClinicalDataComplete(values);
}
